const getSubmit = (form) => form.querySelector('.button[type=submit]');
export function initForm(name, moxi=window.moxi) {
    const client = moxi.ApiClientFactory(window.baseUrl);
    const form_name = name;
    const form_node = document.querySelector('.moxiform.' + form_name.toLowerCase()).querySelector('form');
    const form = new moxi.FrontendForm(form_name, client, moxi.widgets);
    const notifications = document.querySelector('.moxiform > .notifications');

    /** sets the submit buttons loading state to `force` */
    const setLoading = (force) => getSubmit(form_node).classList.toggle('is-loading', force);
    /** catches thrown errors */
    const catcher = (error) => {
        console.error(error);
        window.Bulma(notifications).notification({
            body: moxi.i18n.t('form.' + form_name + '_failure_msg'),
            color: 'danger',
            isDismissable: true,
            destroyOnDismiss: true,
            dismissInterval: 6000,
        }).show();
        setLoading(false);
    }

    document.querySelector('.moxiform.' + form_name.toLowerCase()).querySelector('button[type=submit]').addEventListener('click', function (e) {
        e.preventDefault();
        window.grecaptcha.execute();
        setLoading(true);

        form.send().then(function (response) {
            if (response instanceof Error) {
                setLoading(false);
                throw response;
            }

            form_node.classList.add('is-hidden');
            window.Bulma(notifications).notification({
                body: moxi.i18n.t('form.' + form_name + '_success_msg'),
                color: 'success',
                isDismissable: false,
            }).show();

        }, catcher).catch(catcher);
    });
}
